import toast from 'react-hot-toast'

/** `onError` das mutações de Ocorrências: aviso com a mensagem do backend (o
 * `apiClient` já a põe no `Error`), ou o texto padrão da ação. */
export const errorToast = (fallback: string) => (err: unknown) => {
  toast.error(err instanceof Error ? err.message : fallback)
}
